import createCommonModule from '@/common/store/modules/common';
import { enabledDisabledFormatter } from '@/common/utils/formatter.bool';
import { STATE_ICON_ENABLED, STATE_ICON_DISABLED } from '@/common/utils/statuses';
import getClusterId from '@/common/store/pinia/storageCluster/getClusterId';
import { useAuthStore } from '@/common/store/pinia/auth';

function resource() {
  const auth = useAuthStore();
  const domainId = auth.currentUser?.domain_id;
  const projectId = auth.currentProject;
  if (domainId && projectId) {
    return Promise.resolve(`/api/v2/domains/${domainId}/projects/${projectId}/s3/users`);
  }
  return getClusterId().then(clusterId => `/api/v2/${clusterId}/s3/users`);
}

export default createCommonModule({
  name: 's3Users',
  namespaced: true,
  pagingMode: 's3',
  resource,
  Model: Object,
  plural: ({ data }) => data.map(user => ({ ...user, id: user.s3_user_id ?? user.id })),
  getters: {
    _mapItem: (state) => id => {
      const user = state.itemsMap[id];
      return user ? {
        ...user,
        name: user.email,
        statusText: enabledDisabledFormatter(user.is_enabled),
        statusIcon: user.is_enabled ? STATE_ICON_ENABLED : STATE_ICON_DISABLED,
        isEnabled: user.is_enabled
      } : {};
    }
  },
  actions: {
    CREATE_PROJECT_USER(_, { domainId, projectId, email }) {
      return this.$api.post(`/api/v2/domains/${domainId}/projects/${projectId}/s3/users`, { email });
    },
    FETCH_KEYS(_, userId) {
      return resource().then(url => this.$api.get(`${url}/${userId}/keys`));
    },
    ADD_KEYS(_, userId) {
      return resource().then(url => this.$api.post(`${url}/${userId}/keys`));
    },
    DELETE_KEYS(_, { userId, keyId }) {
      return resource().then(url => this.$api.delete(`${url}/${userId}/keys/${keyId}`));
    }
  }
});
